import $ from "jquery";
import * as helpers from "../shared/find-a-store-helpers.js";
import "../shared/store-locator/jquery.storelocator.js";
import { mapStyle } from "./map-style.js";
import "url-polyfill";

function OnFindNearest(map, nearestLoc, infoWindow, storeStart, page) {
  const resultCount = $("#result-list ul").children().length;
  const searchLocation = $("#bh-sl-address").val();
  //$('#search-header').text(`${resultCount} ACE stores near ${searchLocation}`)
}

export default (function () {
  window.helpers = helpers;

  // Search string parameter
  const url_string = window.location.href;
  const url = new URL(url_string);
  const searchString = $("#address").text(); //url.searchParams.get('location')
  const overrideOriginString = url.searchParams.get("origin");

  // Fill in the search bar
  $("#bh-sl-address").val(searchString);

  if($("#bh-sl-map-container").storeLocator) {
    $("#bh-sl-map-container").storeLocator({
      debug: false,
      autoComplete: false,
      overrideOriginAddress: overrideOriginString,
      storeLimit: 1,
      showLetters: false,
      specialFocusFirst: true, // Only show nearest location result on the map with a pin
      disableInfoWindows: true,
      markerImg: "../../../../assets/img/marker-ace.svg",
      selectedMarkerImg: "../../../../assets/img/marker-ace.svg",
      markerDim: { height: 80, width: 80 },
      selectedMarkerImgDim: { height: 80, width: 80 },
      originalZoom: "10",
      disableListClicks: true,
      autoGeocode: false,
      pagination: false,
      disableAlphaMarkers: true,
      bounceMarker: false,
      openNearest: true,
      maxDistance: true,
      //queryStringParams: true,
      //addressID: 'location',
      exclusiveFiltering: true,
      filters: {
        status: "C"
      },
      taxonomyFilters: {
        category: "category-filters-container1",
        features: "category-filters-container2",
        city: "city-filter",
        postal: "postal-filter",
      },
      mapSettings: mapStyle,
      dataLocation: "../../../../locations/assets/data/stores.json",
      detailsTemplatePath:
        "../../../../assets/find-a-store-templates/custom-templates/details.html",
      listTemplatePath:
        "../../../../assets/find-a-store-templates/custom-templates/location-list-description.html",
      infowindowTemplatePath:
        "../../../../assets/find-a-store-templates/custom-templates/infowindow-description.html",
      KMLinfowindowTemplatePath:
        "../../../../assets/find-a-store-templates/custom-templates/kml-infowindow-description.html",
      KMLlistTemplatePath:
        "../../../../assets/find-a-store-templates/custom-templates/kml-location-list-description.html",
      callbackNearestLoc: OnFindNearest,
    });
  }
})();
